import moment from 'moment'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  methods: {
    // ============================================
    // REGULARIZATION FILTERS
    // ============================================
    openRegularizationFilterModal() {
      this.regularizationSourceTypeFilterTemp = this.regularizationSourceTypeFilter
      if (this.regularizationDateFilter && Array.isArray(this.regularizationDateFilter) && this.regularizationDateFilter.length === 2) {
        this.regularizationFromDateFilterTemp = moment(this.regularizationDateFilter[0]).format('YYYY-MM-DD')
        this.regularizationToDateFilterTemp = moment(this.regularizationDateFilter[1]).format('YYYY-MM-DD')
      } else {
        this.regularizationFromDateFilterTemp = null
        this.regularizationToDateFilterTemp = null
      }
      this.regularizationLeaveTypeFilterTemp = this.regularizationLeaveTypeFilter
      this.regularizationEmployeeFilterTemp = this.regularizationEmployeeFilter
      this.showRegularizationFilterModal = true
    },
    async applyRegularizationFilters(bvModalEvt) {
      this.regularizationSourceTypeFilter = this.regularizationSourceTypeFilterTemp

      if (this.regularizationFromDateFilterTemp && this.regularizationToDateFilterTemp) {
        const startDate = moment(this.regularizationFromDateFilterTemp, 'YYYY-MM-DD', true)
        const endDate = moment(this.regularizationToDateFilterTemp, 'YYYY-MM-DD', true)
        if (!startDate.isValid() || !endDate.isValid()) {
          this.regularizationDateFilter = null
        } else if (startDate.isAfter(endDate, 'day')) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'From Date cannot be after To Date',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          }, { timeout: 3000 })
          if (bvModalEvt && typeof bvModalEvt.preventDefault === 'function') {
            bvModalEvt.preventDefault()
          }
          return
        } else {
          this.regularizationDateFilter = [
            startDate.format('YYYY-MM-DD'),
            endDate.format('YYYY-MM-DD'),
          ]
        }
      } else if (this.regularizationFromDateFilterTemp || this.regularizationToDateFilterTemp) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Please select both From Date and To Date',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        }, { timeout: 3000 })
        if (bvModalEvt && typeof bvModalEvt.preventDefault === 'function') {
          bvModalEvt.preventDefault()
        }
        return
      } else {
        this.regularizationDateFilter = null
      }

      this.regularizationLeaveTypeFilter = this.regularizationLeaveTypeFilterTemp
      this.regularizationEmployeeFilter = this.regularizationEmployeeFilterTemp != null ? this.regularizationEmployeeFilterTemp : null

      this.resetRegularizationDisplay()
      this.resetLeavesDisplay()
      this.showRegularizationFilterModal = false

      await this.loadFilteredData()
    },
    async loadFilteredData() {
      const filters = {}

      if (this.regularizationDateFilter && Array.isArray(this.regularizationDateFilter) && this.regularizationDateFilter.length === 2) {
        filters.startDate = moment(this.regularizationDateFilter[0]).format('YYYY-MM-DD')
        filters.endDate = moment(this.regularizationDateFilter[1]).format('YYYY-MM-DD')
      }

      if (this.regularizationLeaveTypeFilter !== null && this.regularizationLeaveTypeFilter !== undefined) {
        filters.leaveType = this.regularizationLeaveTypeFilter
      }

      this.activeFilters = Object.keys(filters).length > 0 ? filters : null
      this.activeSourceTypeFilter = this.regularizationSourceTypeFilter

      const targetEmpId = this.currentViewEmpId || this.emp_id

      try {
        if ((this.viewMode === 'team' || this.viewMode === 'org') && (this.isHRDirector || this.isHR || this.isAccountManager)) {
          await this.loadAllTeamLeaves()
        } else {
          await Promise.all([
            this.loadMyLeaves(targetEmpId),
            this.loadRegularizationCases(targetEmpId),
          ])
        }
      } catch (err) {
        console.error('Error loading filtered data:', err)
      }
    },
    async clearRegularizationFilters() {
      this.regularizationSourceTypeFilter = 'all'
      this.regularizationDateFilter = null
      this.regularizationLeaveTypeFilter = null
      this.regularizationEmployeeFilter = null
      this.regularizationSourceTypeFilterTemp = 'all'
      this.regularizationFromDateFilterTemp = null
      this.regularizationToDateFilterTemp = null
      this.regularizationLeaveTypeFilterTemp = null
      this.regularizationEmployeeFilterTemp = null
      this.teamLeaveFilter = 'all'
      this.teamRegularizationFilter = 'all'
      this.activeFilters = null
      this.activeSourceTypeFilter = 'all'
      this.resetRegularizationDisplay()
      this.resetLeavesDisplay()
      await this.loadFilteredData()
    },
    loadMoreRegularizations() {
      this.displayedRegularizationCount += this.regularizationDisplayLimit
    },
    resetRegularizationDisplay() {
      this.displayedRegularizationCount = this.regularizationDisplayLimit
    },
    loadMoreLeaves() {
      this.displayedLeavesCount += this.regularizationDisplayLimit
    },
    resetLeavesDisplay() {
      this.displayedLeavesCount = this.regularizationDisplayLimit
    },

    // ============================================
    // MAIN FILTER MODAL
    // ============================================
    openFilterModal() {
      this.viewModeTemp = this.viewMode

      if (this.dateRangeFilter && Array.isArray(this.dateRangeFilter) && this.dateRangeFilter.length === 2) {
        this.fromDateFilterTemp = this.dateRangeFilter[0]
        this.toDateFilterTemp = this.dateRangeFilter[1]
        this.dateRangeFilterTemp = [this.dateRangeFilter[0], this.dateRangeFilter[1]]
      } else {
        this.fromDateFilterTemp = null
        this.toDateFilterTemp = null
        this.dateRangeFilterTemp = null
      }

      this.selectedAccountManagerTemp = this.selectedAccountManager
      this.selectedTeamWiseEmployeeTemp = this.selectedTeamWiseEmployee
      this.selectedTeamMemberTemp = this.selectedTeamMember

      if (this.selectedAccountManagerTemp && (this.viewModeTemp === 'org' || this.viewModeTemp === 'team') && this.canApplyOnBehalfAll) {
        this.loadEmployeesForAccountManager(this.selectedAccountManagerTemp)
      }

      this.showFilterModal = true
    },
    async handleFilterApply() {
      if (this.viewModeTemp !== this.viewMode && this.canViewTeam) {
        this.viewMode = this.viewModeTemp
        this.handleViewModeChange()
      }

      if (this.fromDateFilterTemp && this.toDateFilterTemp) {
        const startDate = moment(this.fromDateFilterTemp)
        const endDate = moment(this.toDateFilterTemp)
        if (startDate.isValid() && endDate.isValid()) {
          if (startDate.isAfter(endDate, 'day')) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'From Date cannot be after To Date',
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            }, { timeout: 3000 })
            return
          }
          this.dateRangeFilter = [
            startDate.format('YYYY-MM-DD'),
            endDate.format('YYYY-MM-DD'),
          ]
          this.dateRangeFilterTemp = [startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')]
        } else {
          this.dateRangeFilter = null
          this.dateRangeFilterTemp = null
        }
      } else if (this.fromDateFilterTemp || this.toDateFilterTemp) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Please select both From Date and To Date',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        }, { timeout: 3000 })
        return
      } else {
        this.dateRangeFilter = null
        this.dateRangeFilterTemp = null
      }

      if (this.viewModeTemp === 'org' && this.canApplyOnBehalfAll) {
        if (this.selectedAccountManagerTemp !== this.selectedAccountManager) {
          const previousAccountManager = this.selectedAccountManager
          this.selectedAccountManager = this.selectedAccountManagerTemp
          const employeeToSelect = this.selectedTeamWiseEmployeeTemp

          if (this.selectedAccountManager) {
            await this.handleAccountManagerChange()
            if (employeeToSelect) {
              this.selectedTeamWiseEmployee = employeeToSelect
              this.selectedTeamWiseEmployeeTemp = employeeToSelect
              this.currentViewEmpId = this.selectedTeamWiseEmployee || this.emp_id
              await this.handleTeamWiseEmployeeChange()
            } else {
              this.selectedTeamWiseEmployee = null
              this.selectedTeamWiseEmployeeTemp = null
              this.currentViewEmpId = this.emp_id
            }
          } else {
            this.selectedTeamWiseEmployee = null
            this.selectedTeamWiseEmployeeTemp = null
            this.currentViewEmpId = this.emp_id
            if (previousAccountManager !== null) {
              await this.handleAccountManagerChange()
            }
          }
        } else if (this.selectedAccountManager) {
          if (this.selectedTeamWiseEmployeeTemp !== this.selectedTeamWiseEmployee) {
            this.selectedTeamWiseEmployee = this.selectedTeamWiseEmployeeTemp
            this.currentViewEmpId = this.selectedTeamWiseEmployee || this.emp_id
            await this.handleTeamWiseEmployeeChange()
          } else {
            await this.loadData()
          }
        } else if (this.selectedTeamWiseEmployeeTemp) {
          this.selectedTeamWiseEmployee = this.selectedTeamWiseEmployeeTemp
          this.currentViewEmpId = this.selectedTeamWiseEmployee
          await this.handleTeamWiseEmployeeChange()
        } else {
          await this.loadData()
        }
      }

      if (this.viewModeTemp === 'team' && this.canApplyOnBehalfAll) {
        if (this.selectedAccountManagerTemp !== this.selectedAccountManager) {
          const previousAccountManager = this.selectedAccountManager
          this.selectedAccountManager = this.selectedAccountManagerTemp
          const employeeToSelect = this.selectedTeamWiseEmployeeTemp

          if (this.selectedAccountManager) {
            await this.handleAccountManagerChange()
            if (employeeToSelect) {
              this.selectedTeamWiseEmployee = employeeToSelect
              this.selectedTeamWiseEmployeeTemp = employeeToSelect
              this.currentViewEmpId = this.selectedTeamWiseEmployee || this.emp_id
              await this.handleTeamWiseEmployeeChange()
            } else {
              this.selectedTeamWiseEmployee = null
              this.selectedTeamWiseEmployeeTemp = null
              this.currentViewEmpId = this.emp_id
            }
          } else {
            this.selectedTeamWiseEmployee = null
            this.selectedTeamWiseEmployeeTemp = null
            this.currentViewEmpId = this.emp_id
            if (previousAccountManager !== null) {
              await this.handleAccountManagerChange()
            }
          }
        } else if (this.selectedAccountManager) {
          if (this.selectedTeamWiseEmployeeTemp !== this.selectedTeamWiseEmployee) {
            this.selectedTeamWiseEmployee = this.selectedTeamWiseEmployeeTemp
            this.currentViewEmpId = this.selectedTeamWiseEmployee || this.emp_id
            await this.handleTeamWiseEmployeeChange()
          } else {
            await this.loadData()
          }
        } else if (this.selectedTeamWiseEmployeeTemp) {
          this.selectedTeamWiseEmployee = this.selectedTeamWiseEmployeeTemp
          this.currentViewEmpId = this.selectedTeamWiseEmployee
          await this.handleTeamWiseEmployeeChange()
        } else {
          await this.loadData()
        }
      }

      if (this.viewModeTemp === 'team' && this.isAccountManager) {
        this.selectedTeamMember = this.selectedTeamMemberTemp || null
        this.handleTeamMemberChange()
      }

      this.showFilterModal = false
    },
    clearAllFilters() {
      this.dateRangeFilter = null
      this.dateRangeFilterTemp = null
      this.fromDateFilterTemp = null
      this.toDateFilterTemp = null

      this.teamLeaveFilter = 'all'
      this.teamRegularizationFilter = 'all'

      if (this.viewMode === 'org' && this.canApplyOnBehalfAll) {
        this.selectedAccountManager = null
        this.selectedAccountManagerTemp = null
        this.selectedTeamWiseEmployee = null
        this.selectedTeamWiseEmployeeTemp = null
        this.currentViewEmpId = this.emp_id
        this.handleAccountManagerChange()
      }

      if (this.viewMode === 'team' && this.canApplyOnBehalfAll) {
        this.selectedTeamWiseEmployee = null
        this.selectedTeamWiseEmployeeTemp = null
        this.currentViewEmpId = this.emp_id
        this.teamWiseEmployees = []
        this.loadData()
      }

      if (this.viewMode === 'team' && this.isAccountManager) {
        this.selectedTeamMember = null
        this.selectedTeamMemberTemp = null
        this.currentViewEmpId = this.emp_id
        this.handleTeamMemberChange()
      }
    },
    handleDateRangeFilterApply() {
      if (this.dateRangeFilterTemp && Array.isArray(this.dateRangeFilterTemp) && this.dateRangeFilterTemp.length === 2) {
        const startDate = moment(this.dateRangeFilterTemp[0])
        const endDate = moment(this.dateRangeFilterTemp[1])
        if (startDate.isValid() && endDate.isValid()) {
          this.dateRangeFilter = [
            startDate.format('YYYY-MM-DD'),
            endDate.format('YYYY-MM-DD'),
          ]
          this.showDateRangePicker = false
          return
        }
      }

      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Please select a valid date range',
          icon: 'AlertCircleIcon',
          variant: 'warning',
        },
      }, { timeout: 3000 })
      this.$nextTick(() => {
        this.showDateRangePicker = true
      })
    },
    handleDateRangeFilterChange(selectedDates, dateStr, instance) {
      if (this.dateRangeFilterDebounceTimer) {
        clearTimeout(this.dateRangeFilterDebounceTimer)
      }

      this.dateRangeFilterDebounceTimer = setTimeout(() => {
        if (selectedDates && selectedDates.length === 2) {
          this.dateRangeFilterTemp = [
            moment(selectedDates[0]).format('YYYY-MM-DD'),
            moment(selectedDates[1]).format('YYYY-MM-DD'),
          ]
        } else if (selectedDates && selectedDates.length === 1) {
          this.dateRangeFilterTemp = [moment(selectedDates[0]).format('YYYY-MM-DD')]
        } else {
          this.dateRangeFilterTemp = null
        }
        this.dateRangeFilterDebounceTimer = null
      }, 150)
    },
  },
}
